<template>
  <div class="pre_table-header" ref="table">
    <ul class="header">
      <li class="column_item">
        <p class="pre_label item_table" :style="{width:labelWidth+'px'}">{{title}}</p>
        <div
          v-for="(item,index) of headerData"
          :key="index"
          class="pre_data item_table"
          :style="{width:widthItem+'px'}"
        >
          <p v-for="(itemData,j) of item" :key="j" class="item_data">{{itemData}}</p>
        </div>
      </li>
      <li class="column_item">
        <p class="pre_label item_table fix_table" :style="{width:labelWidth+'px'}">Exchange rate</p>
        <div
          v-for="(item,index) of rateData"
          :key="index"
          class="pre_data item_table fix_table"
          :style="{width:widthItem+'px'}"
        >
          <p v-for="(itemData,j) of item" :key="j" class="item_data">{{itemData}}</p>
        </div>
      </li>
    </ul>

    <!--  -->
    <ul class="body">
      <li class="column_item" v-for="(item,index) of column" :key="index">
        <p
          class="pre_label item_table pre_table_label"
          :title="item.label"
          :style="{width:labelWidth+'px'}"
        >{{item.label}}</p>
        <span
          class="pre_data item_table pre_table_data"
          v-for="(itemData,j) of tableData[item.field]"
          :key="j"
          :title="itemData"
          :style="{width:widthItem+'px'}"
        >{{itemData || "-"}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import Config from "conf/Transcation";
import { mapState } from "vuex";

export default {
  props: ["title", "data", "column", "headerColumn"],

  data() {
    return {
      ConfigData: {},
      labelWidth: 200,
      widthItem: 0,
      date: "",
      headerData: [],
      rateData: [],
      tableData: []
    };
  },

  created() {
    this.widthComputed();
  },

  methods: {
    // setDate() {
    //   this.ConfigData = this.$lodash.cloneDeep(Config);
    //   this.date = "31/12/2017";
    //   let month = 12;
    //   this.ConfigData.preHeaderData.unshift([`${month} months`]);
    //   this.ConfigData.preHeaderData.forEach(item => {
    //     item.unshift(this.date);
    //   });

    //   const rate = "th EUR";
    //   this.rateData.push([rate], [], [], [], [], []);

    //   this.tableData = {
    //     a: ["26,624,419", "3.48", "2.73", "3.48", "3.41", "3.48"]
    //   };
    // },

    setData(data) {
      this.headerData = this.$lodash.cloneDeep(this.headerColumn);
      this.headerData.unshift([`${data.month} months`]);
      this.headerData.forEach(item => {
        item.unshift(data.date);
      });
      this.rateData = [];
      this.rateData.push([data.rate], [], [], [], [], []);
      this.tableData = data.tableData;
      // console.log("TCL: setData -> this.tableData", this.tableData)
    },

    widthComputed() {
      this.$nextTick(() => {
        const contaierWidth = this.$refs.table.clientWidth;
        this.widthItem = (contaierWidth - this.labelWidth) / 6;
        // console.log("TCL: widthComputed -> widthItem", widthItem)
      });
    }
  },

  computed: {
    ...mapState({
      isCollapse(state) {
        return state.Collapse.isCollapse;
      }
    })
  },

  watch: {
    // isCollapse(newValue) {
    //   if (newValue) {
    //     this.labelWidth = 400;
    //   } else this.labelWidth = 200;
    //   setTimeout(() => {
    //     this.widthComputed();
    //   }, 600);
    //   // 展开收缩有一个动画延迟  如果不延迟则  会获取动画开始前的宽度 而不是之后的宽度
    // },

    data: {
      handler(data) {
        this.setData(data);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.item_table {
  display: inline-block;
  color: #4e5671;
  border: 1px solid #f3f4f5;
  padding: 0px 10px;
  border-bottom: none;
  border-right: none;
  text-align: center;
}
.pre_label {
  /* width: 200px; */
  vertical-align: top;
  height: 150px;
  line-height: 36px;
  font-weight: 600;
  background: #f7f8fa;
}
.pre_data {
  vertical-align: top;
  height: 150px;
  line-height: 36px;
  padding-top: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.pre_table_label,
.pre_table_data {
  height: 80px;
}

ul {
  min-width: 100%;
  border-right: 1px solid #f3f4f5;
  margin-bottom: 20px;
  border-bottom: 1px solid #f3f4f5;
}
.column_item {
  width: 100%;
  white-space: nowrap;
  font-size: 13px;
}
.pre_table-header {
  overflow-x: auto;
}
.item_data {
  /* display: inline; */
  line-height: 20px;
}
.pre_label {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
  vertical-align: bottom; /* overflow 会带来元素塌陷   需要设置vertical-align*/
}
/* //修复bug标记 02 */
.fix_table {
  height: 70px !important;
}
</style>